export default function DS_Database_Table() {
  return <div>DS_Database_Table Component</div>;
}
